<!-- Light & Dark version -->
<div class="logo-style" matRipple>
    <h1 class="text-style">OnePlacement.</h1>
</div>
